module.exports = __webpack_public_path__ + "img/upload-signature.77111ad9.svg";